import type { ReactNode } from 'react';

export interface Column<Row> {
  readonly header: string;
  readonly cell: (row: Row) => ReactNode;
}

export function DataTable<Row extends { readonly id: string }>(props: {
  caption: string;
  columns: readonly Column<Row>[];
  rows: readonly Row[];
}) {
  return (
    <table>
      <caption>{props.caption}</caption>
      <thead>
        <tr>
          {props.columns.map((column) => (
            <th key={column.header} scope="col">
              {column.header}
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {props.rows.map((row) => (
          <tr key={row.id}>
            {props.columns.map((column) => (
              <td key={column.header}>{column.cell(row)}</td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
}
